module.exports = __webpack_public_path__ + "img/eye-opened.0764514e.svg";